import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/coinmerce.webp';
import screenshot_target from '../../../images/letterfunnel/jaapdebruijn.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jaap de Bruijn"
      firstname="Jaap"
      companyname="Coinmerce"
      competition="Bitvavo en Finst"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jaapdebruijn.js